import { render } from "./ShapesIcon.vue?vue&type=template&id=9031849c"
import script from "./ShapesIcon.vue?vue&type=script&lang=js"
export * from "./ShapesIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__